import STBoardComments from "../../../assets/styles/organisms/boardComment.module.scss";
import STButton from "../../../assets/styles/atoms/button.module.scss";
import { useGetNextPage } from "./hooks";
import { useBoard } from "../../../providers/BoardDetailProvider";

const LoadMoreButton = () => {
  const { handleGetNextPage } = useGetNextPage();
  const {
    state: { hasMore },
  } = useBoard();
  if (!hasMore) {
    return null;
  }
  return (
    <div className={STBoardComments.loadMoreCommentsContainer}>
      <button
        className={`${STBoardComments.loadMoreComments} ${STButton.primary}`}
        onClick={handleGetNextPage}
      >
        コメントをもっと見る
      </button>
    </div>
  );
};

export default LoadMoreButton;
